export function getVariantClass(base: string, variant: string, prefix?: string) {
  return `${base}--${prefix ? `${prefix}-` : ''}${variant}`;
}

export function getBooleanVariants(base: string, variantBooleanMap: any, prefix?: string): string[] {
  return Object.keys(variantBooleanMap)
    .filter((variant) => variantBooleanMap[variant])
    .map((variant) => getVariantClass(base, variant, prefix));
}

export function getVariantsWithPrefix(base: string, prefixVariantMap: any): string[] {
  return Object.keys(prefixVariantMap)
    .filter((prefix) => prefixVariantMap[prefix])
    .map((prefix) => getVariantClass(base, prefixVariantMap[prefix], prefix));
}

export function camelToHyphen(camel: string): string {
  return camel.replace(/([A-Z])/g, ($1) => (`-${$1.toLowerCase()}`));
}

export function snakeToHyphen(snake: string): string {
  return snake.replace('_', '-');
}

export type BackgroundColors = 'primary' | 'white' | 'light' | 'lowlight' | 'slate' | 'black';
export type Colors = 'primary' | 'white' | 'ink_light' | 'ink_lighter' | 'ink_lightest' | 'ink' | 'black';

const CONTRASTING_MAP = {
  primary: 'white',
  white: 'ink_light',
  light: 'ink',
  lowlight: 'white',
  slate: 'ink_lightest',
  black: 'white',
};

export function getContrastingColor(color) {
  return CONTRASTING_MAP[color] || null;
}

const BACKGROUND_BASE = 'background';
const COLOR_BASE = 'color';

export function getColorClasses(background: BackgroundColors, color?: Colors) {
  const backgroundClass = getVariantClass(BACKGROUND_BASE, background);
  const colorClass = color ? getVariantClass(COLOR_BASE, color) : '';
  return [backgroundClass, colorClass].join(' ');
}
